import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ThumbUpIcon from '@material-ui/icons/ThumbUpAltOutlined';

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', alignItems: 'center' },
  icon: { marginRight: 8 },
  text: { fontSize: '1.3em' },
}));

export default function EmptyRequests() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ThumbUpIcon color="primary" className={classes.icon} />
      <p className={classes.text}>No Requests.</p>
    </div>
  );
}
